<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>تغییر رمز عبور</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.last_password.val" :description="form.last_password.inv"
                                        label="رمز عبور" type="password" dir="ltr" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.password.val" :description="form.password.inv"
                                        label="رمز عبور جدید" type="password" dir="ltr" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.repeat_password.val" :description="form.repeat_password.inv"
                                        label="تکرار رمز عبور جدید" type="password" dir="ltr" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ارسال</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                last_password: {val: '', inv: '', v: { req: true, max: 64 }},
                password: {val: '', inv: '', v: { req: true, max: 64 }},
                repeat_password: {val: '', inv: '', v: { req: true, max: 64 }},
            },
            disable: false,
        }
    },
    methods: {
        submit(){
            if (this.disable == false) {
                const data = new FormData();
                for (const key in this.form) {
                    if(key != 'repeat_password'){
                        data.set(key, this.form[key].val);
                    }
                }
                data.set('ids', JSON.stringify([parseInt(this.$route.params.id)]));
                this.axios.put('users/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ارسال با موفقیت انجام شد.'
                        });
                        for (const key in this.form) {
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'نام کاربری یا رمز عبور اشتباه است.'
                        });
                    })
            }
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.update_all_users == false
            && this.$store.state.perms.update_same_group_users == false
            && this.$store.state.perms.update_user_info == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
